export const COMPANY = {
  name: 'Lac Léman',
  parent: 'Mirabaud Group',
  parentSince: '1819',
  operatingSince: '2014',
  tagline: 'Marketing capital. Elevating investments.',
  description:
    'The dedicated operational marketing agency of the Mirabaud Group, executing global capital-raising campaigns, investor positioning, and strategic communications for Mirabaud investment projects.',
  address: "Quai de l'Île 13, 1204 Geneva, Switzerland",
  phone: '+41 22 819 11 11',
  email: 'contact@lacleman-mirabaud.ch',
};

export const IMAGES = {
  genevaLake:
    'https://images.unsplash.com/photo-1742649266481-30b0ef9d57bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHw0fHxnZW5ldmElMjBzd2l0emVybGFuZCUyMGFyY2hpdGVjdHVyZSUyMGxha2UlMjBsZW1hbnxlbnwwfHx8fDE3ODg3OTEwODl8MA&ixlib=rb-4.1.0&q=85',
  jetDeau:
    'https://images.unsplash.com/photo-1667758682790-c58fa23dc76f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHxnZW5ldmElMjBzd2l0emVybGFuZCUyMGFyY2hpdGVjdHVyZSUyMGxha2UlMjBsZW1hbnxlbnwwfHx8fDE3ODg3OTEwODl8MA&ixlib=rb-4.1.0&q=85',
  investmentBuilding:
    'https://images.unsplash.com/photo-1683290844875-0eee4089069a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBpbnZlc3RtZW50JTIwZmluYW5jZSUyMGFyY2hpdGVjdHVyZSUyMGJ1aWxkaW5nfGVufDB8fHx8MTc4ODc5MTA4OXww&ixlib=rb-4.1.0&q=85',
  bankInterior:
    'https://images.unsplash.com/photo-1613490493576-7fde63acd811?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBpbnZlc3RtZW50JTIwZmluYW5jZSUyMGFyY2hpdGVjdHVyZSUyMGJ1aWxkaW5nfGVufDB8fHx8MTc4ODc5MTA4OXww&ixlib=rb-4.1.0&q=85',
};

export const PROJECTS = [
  {
    id: 'andes-hydro',
    region: 'Latin America',
    regionKey: 'latam',
    country: 'Chile & Colombia',
    title: 'Proyecto Andes Hydroelectric & Solar Fund',
    capital: '$450 Million USD',
    year: '2021 – 2023',
    description:
      "Full-stack investor positioning and marketing campaign for Mirabaud's flagship renewable energy infrastructure fund across Latin American markets.",
    deliverables: [
      'Institutional Pitchbook',
      '3D Interactive Asset Portal',
      'Global Investor Roadshow Assets',
      'Impact Video Documentary',
    ],
    image:
      'https://images.pexels.com/photos/9893727/pexels-photo-9893727.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    testid: 'project-card-andes-hydro',
  },
  {
    id: 'bioreserva',
    region: 'Latin America',
    regionKey: 'latam',
    country: 'Brazil (Amazon Basin)',
    title: 'BioReserva Amazônia Sustainable Forestry',
    capital: '$180 Million USD',
    year: '2019 – 2020',
    description:
      'Strategic private placement marketing for sustainable timberland and carbon-credit asset management fund targeting European family offices.',
    deliverables: [
      'Private Placement Memorandum Visuals',
      'Carbon Footprint Dashboard Design',
      'Executive Dinner Series Curation',
    ],
    image:
      'https://images.unsplash.com/photo-1616148378110-de439f6b7cd4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwyfHxzb2xhciUyMGVuZXJneSUyMGZhcm0lMjBsYXRpbiUyMGFtZXJpY2F8ZW58MHx8fHwxNzg4NzkxMDk2fDA&ixlib=rb-4.1.0&q=85',
    testid: 'project-card-bioreserva',
  },
  {
    id: 'helios-solar',
    region: 'Africa',
    regionKey: 'africa',
    country: 'Kenya & East Africa Corridor',
    title: 'Helios Solar Infrastructure Initiative',
    capital: '$220 Million USD',
    year: '2022 – 2024',
    description:
      'Comprehensive branding and investor communication strategy for off-grid commercial & industrial solar installations, backed by sovereign wealth co-investors.',
    deliverables: [
      'ESG Compliance Dossier',
      'Interactive Regional Map Experience',
      'Media & Institutional PR Suite',
    ],
    image:
      'https://images.unsplash.com/photo-1753881110611-00755160afd2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHw0fHxzdXN0YWluYWJsZSUyMGluZnJhc3RydWN0dXJlJTIwYWZyaWNhJTIwc29sYXIlMjBhZ3JpY3VsdHVyZXxlbnwwfHx8fDE3ODg3OTEwOTZ8MA&ixlib=rb-4.1.0&q=85',
    testid: 'project-card-helios-solar',
  },
  {
    id: 'alpine-horizon',
    region: 'Switzerland',
    regionKey: 'swiss',
    country: 'Zermatt & Geneva',
    title: 'Alpine Horizon Luxury Eco-Resort & Real Estate Bond',
    capital: 'CHF 310 Million',
    year: '2017 – 2018',
    description:
      "Exclusive campaign design and high-net-worth investor materials for Mirabaud's green bond issuance financing ultra-luxury alpine real estate.",
    deliverables: [
      'Architectural VIP Dossier',
      'Private Client Event Visual Identity',
      'Bespoke Leather-Bound Prospectus',
    ],
    image:
      'https://images.unsplash.com/photo-1767350759731-5a27b1228828?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxzd2l0emVybGFuZCUyMGx1eHVyeSUyMHJlYWwlMjBlc3RhdGUlMjBhbHBpbmUlMjBjb21tZXJjaWFsfGVufDB8fHx8MTc4ODc5MTA5Nnww&ixlib=rb-4.1.0&q=85',
    testid: 'project-card-alpine-horizon',
  },
];

export const SERVICES = [
  {
    title: 'Investor Positioning',
    description:
      'Narrative architecture and market positioning that translates complex investment theses into compelling institutional stories.',
  },
  {
    title: 'Capital-Raising Campaigns',
    description:
      'End-to-end campaign strategy and execution for fund launches, private placements, and bond issuances across global markets.',
  },
  {
    title: 'Pitchbooks & Collateral',
    description:
      'Institutional-grade pitchbooks, private placement memoranda, and bespoke investor materials crafted to Swiss standards.',
  },
  {
    title: 'Digital Asset Portals',
    description:
      'Interactive investor portals, data dashboards, and immersive project experiences that bring assets to life.',
  },
  {
    title: 'Roadshows & Events',
    description:
      'Global investor roadshows, executive dinner series, and private client events curated with Geneva discretion.',
  },
  {
    title: 'ESG & Impact Communications',
    description:
      'Sustainability dossiers, impact reporting, and ESG narratives aligned with institutional compliance frameworks.',
  },
];

export const TIMELINE = [
  {
    year: '1819',
    title: 'Mirabaud Founded',
    text: 'The Mirabaud Group is established in Geneva, beginning over two centuries of Swiss private banking heritage.',
  },
  {
    year: '2014',
    title: 'Lac Léman Established',
    text: 'Lac Léman is founded as the dedicated operational marketing branch of Mirabaud, based on Quai de l\'Île in Geneva.',
  },
  {
    year: '2017',
    title: 'First Flagship Issuance',
    text: 'Launch of the Alpine Horizon green bond campaign — CHF 310M raised for luxury alpine real estate.',
  },
  {
    year: '2019',
    title: 'Latin America Expansion',
    text: 'BioReserva Amazônia marks our first private placement campaign in South American markets.',
  },
  {
    year: '2021',
    title: 'Largest Campaign to Date',
    text: 'Proyecto Andes closes at $450M — our largest renewable infrastructure marketing engagement.',
  },
  {
    year: '2024',
    title: 'African Corridor',
    text: 'Helios Solar Initiative extends Mirabaud\'s investor reach into the East African energy corridor.',
  },
];
